module.exports = __webpack_public_path__ + "static/media/day10.ed2c2ed0.jpg";